import { Redirect, Route, Switch } from "react-router";

import PageTitle from "../../ui/PageTitle/PageTitle";

import { USER_REFERENCE_URLS, IUserReferenceProps } from "./module/constants";
import { ROUTES } from "../../module/constants";

import UsersReferencenStepOne from "./UsersReferencenStepOne/UsersReferencenStepOne";
import UsersReferenceStepTwo from "./UsersReferenceStepTwo/UsersReferenceStepTwo";
import ErrorPage from "../ErrorPage/Loadable";

import messages from "./module/messages";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

const UsersReference = (props: IUserReferenceProps) => {
  return (
    <>
      <PageTitle title={messages.pageTitle} />
      <Switch>
        <Route
          strict
          exact
          path={ROUTES.USERSREFERENCE}
          component={UsersReferencenStepOne}
        />
        <Route
          strict
          exact
          path={USER_REFERENCE_URLS.USER_DETAIL}
          component={UsersReferenceStepTwo}
        />
        <Route path={ROUTES.FORBIDDEN} component={ErrorPage} />
        <Redirect path={"*"} to={{ pathname: ROUTES.FORBIDDEN }} />
      </Switch>
    </>
  );
};

const mapStateToProps: any = () => createStructuredSelector({});

const mapDispatchToProps: any = {};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(UsersReference);
